var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { metadata, metadataOf } from "./metadata";
import { optional } from "./optional";
export function persisted(target, key) {
    var _a = metadataOf(target).persisted, persisted = _a === void 0 ? [] : _a;
    metadata(target, {
        persisted: __spreadArrays(persisted, [
            { key: key }
        ])
    });
}
export function getSnapshot(context) {
    return context.services.reduce(function (acc, service) {
        var id = metadataOf(service).id;
        var obj = getServiceSnapshot(service);
        if (obj)
            acc[id] = obj;
        return acc;
    }, {});
}
export function getServiceSnapshot(service) {
    var _a = metadataOf(service).persisted, persisted = _a === void 0 ? [] : _a;
    if (persisted.length > 0) {
        var obj_1 = {};
        persisted.forEach(function (meta) {
            var key = meta.key;
            obj_1[key] = service[key];
        });
        return obj_1;
    }
}
export function restoreSnapshot(context, d) {
    context.services.forEach(function (service) {
        var id = metadataOf(service).id;
        restoreServiceSnapshot(service, d[id]);
    });
}
export function restoreServiceSnapshot(service, data) {
    var _a = metadataOf(service).persisted, persisted = _a === void 0 ? [] : _a;
    if (persisted.length > 0) {
        if (!!data) {
            persisted.forEach(function (meta) {
                var key = meta.key;
                if (typeof data[key] !== 'undefined') {
                    service[key] = data[key];
                }
            });
        }
    }
    return false;
}
export function browserPersist(context, data, onSave) {
    if (!!data)
        optional(function () { return restoreSnapshot(context, JSON.parse(data)); });
    ['visibilitychange', 'pagehide', 'freeze'].forEach(function (type) {
        window.addEventListener(type, function () {
            if (type === 'visibilitychange' && document.visibilityState === 'visible')
                return;
            onSave(JSON.stringify(getSnapshot(context)));
        }, { capture: true });
    });
}
